import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Product } from 'src/pages/deprecated/payment/types';
import { ChallengeAddOnProduct } from 'src/pages/signup/steps/extras/types/challenge.types';

export type ChallengeAddonModal = {
  isAddonContentModalOpen?: boolean;
  isShippingAddressModalOpen?: boolean;
  isConfirmationModalOpen?: boolean;
};

export interface PaymentStateType {
  isPaymentProcessing: boolean;
  isPaymentIntentLoading: boolean;
  isPaymentIntentError: boolean;

  // addons
  addOnProducts: Product[];
  challengeAddOnProduct: ChallengeAddOnProduct | null;
  personalCoachPriceId: string | null;
  personalCoachPriceAmount?: number | null;
  isPersonalCoachingAdded?: boolean;
  challengeModalOpen?: ChallengeAddonModal;
}

const initialState: PaymentStateType = {
  isPaymentProcessing: false,
  isPaymentIntentLoading: false,
  isPaymentIntentError: false,

  // addons
  addOnProducts: [],
  challengeAddOnProduct: null,
  personalCoachPriceId: null,
  isPersonalCoachingAdded: false,
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentProcessing: (state, action: PayloadAction<boolean>) => {
      state.isPaymentProcessing = action.payload;
    },
    setPaymentIntentLoading: (state, action: PayloadAction<boolean>) => {
      state.isPaymentIntentLoading = action.payload;
    },
    setPaymentIntentError: (state, action: PayloadAction<boolean>) => {
      state.isPaymentIntentError = action.payload;
    },
    setAddOnProducts: (state, action: PayloadAction<Product[]>) => {
      state.addOnProducts = action.payload;
    },
    setPersonalCoachPriceId: (state, action: PayloadAction<string | null>) => {
      state.personalCoachPriceId = action.payload;
    },
    setPersonalCoachPriceAmount: (
      state,
      action: PayloadAction<number | null>
    ) => {
      state.personalCoachPriceAmount = action.payload;
    },
    setChallengeAddOnProduct: (
      state,
      action: PayloadAction<ChallengeAddOnProduct | null>
    ) => {
      state.challengeAddOnProduct = action.payload;
    },
    setIsPersonalCoachAddonAdded: (state, action: PayloadAction<boolean>) => {
      state.isPersonalCoachingAdded = action.payload;
    },
    setChallengeModalOpen: (
      state,
      action: PayloadAction<ChallengeAddonModal>
    ) => {
      state.challengeModalOpen = {
        ...state.challengeModalOpen,
        ...action.payload,
      };
    },
  },
});

export const {
  setPaymentProcessing,
  setPaymentIntentLoading,
  setPaymentIntentError,

  setAddOnProducts,
  setPersonalCoachPriceId,
  setIsPersonalCoachAddonAdded,
  setChallengeAddOnProduct,
  setChallengeModalOpen,
  setPersonalCoachPriceAmount,
} = paymentSlice.actions;

export default paymentSlice.reducer;
